import { render } from "./ViewDetails.vue?vue&type=template&id=7d9eac52&scoped=true"
import script from "./ViewDetails.vue?vue&type=script&lang=js"
export * from "./ViewDetails.vue?vue&type=script&lang=js"

import "./ViewDetails.vue?vue&type=style&index=0&id=7d9eac52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d9eac52"

export default script